var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "70", height: "70", viewBox: "0 0 70 70", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "cue/option.inline"
    ),
    React.createElement("path", { d: "M55.173 70.026c-8.284 0-15-6.716-15-15 0-8.285 6.716-15 15-15 8.285 0 15 6.715 15 15 0 8.284-6.715 15-15 15zm-25.17-54.91a15 15 0 1 1-15-14.95c8.265 0 14.973 6.685 15 14.95zm25.03 14.91c-8.284 0-15-6.716-15-15 0-8.285 6.716-15 15-15 8.285 0 15 6.715 15 15 0 8.284-6.715 15-15 15zm-39.86 40.14c-8.284 0-15-6.716-15-15 0-8.285 6.716-15 15-15 8.285 0 15 6.715 15 15 0 8.284-6.715 15-15 15zm49.83-55.05c0-5.523-4.477-10-10-10-5.522 0-10 4.477-10 10s4.478 10 10 10c5.52 0 9.995-4.471 10-9.99v-.01zm0 40c0-5.523-4.477-10-10-10-5.522 0-10 4.477-10 10s4.478 10 10 10c5.52 0 9.995-4.471 10-9.99v-.01zm-40 0c0-5.523-4.477-10-10-10-5.522 0-10 4.477-10 10s4.478 10 10 10c5.52 0 9.995-4.471 10-9.99v-.01z", fill: "#FFF", fillRule: "nonzero" })
  );
});